import { selecetedShopIdActionTypes } from './selected-shop-id-reducer';

export enum orderReducerActionTypes {
  UPDATE_ORDER = 'ORDER_UPDATE_ORDER',
  ADD_ITEM = 'ORDER_ADD_ITEM',
  REMOVE_ITEM = 'ORDER_REMOVE_ITEM',
}

interface OrderUpdateOrderAction {
  type: orderReducerActionTypes.UPDATE_ORDER;
  payload: OrderAddon[];
}

interface OrderAddItemAction {
  type: orderReducerActionTypes.ADD_ITEM;
  payload: OrderAddon;
}

interface OrderRemoveItemAction {
  type: orderReducerActionTypes.REMOVE_ITEM;
  payload: OrderAddon;
}

interface SelecetedShopIdAction {
  type: selecetedShopIdActionTypes.SELECTED_SHOP_ID_UPDATE;
  payload: string;
}

export type OrderReducerAction =
  | OrderUpdateOrderAction
  | OrderAddItemAction
  | OrderRemoveItemAction
  | SelecetedShopIdAction;

interface OrderAddon {
  itemId: string;
  quantity: number;
}

export type OrderReducerState = OrderAddon[];

export const orderReducerInitialState: OrderReducerState = [];

const orderReducer = (
  state: OrderReducerState,
  action: OrderReducerAction
): OrderReducerState => {
  switch (action.type) {
    case orderReducerActionTypes.UPDATE_ORDER: {
      return action.payload;
    }
    case 'ORDER_ADD_ITEM': {
      const updatedAddon = {
        itemId: action.payload.itemId,
        quantity: action.payload.quantity,
      };

      for (const addon of state) {
        if (addon.itemId === action.payload.itemId) {
          updatedAddon.quantity = addon.quantity + action.payload.quantity;

          const indexOfUpdatedAddon = state.findIndex(
            (existingAddon) => existingAddon.itemId === updatedAddon.itemId
          );

          return [
            ...state.slice(0, indexOfUpdatedAddon),
            updatedAddon,
            ...state.slice(indexOfUpdatedAddon + 1),
          ];
        }
      }

      return [...state, updatedAddon];
    }
    case 'ORDER_REMOVE_ITEM': {
      const indexOfAddon = state.findIndex(
        (existingAddon) => existingAddon.itemId === action.payload.itemId
      );

      return [...state.slice(0, indexOfAddon), ...state.slice(indexOfAddon + 1)];
    }
    case selecetedShopIdActionTypes.SELECTED_SHOP_ID_UPDATE: {
      return [];
    }
    default:
      return state;
  }
};

export default orderReducer;
